// Column definitions for the merchant table.
// `width` is a CSS width used by the table's <colgroup>; the values must total 100%
// including the trailing action column defined inside MerchantTable.
export const merchantColumns = [
  { key: "merchantName", label: "Merchant", width: "26%", align: "left" },
  { key: "internalMerchantId", label: "Internal ID", width: "20%", align: "left" },
  { key: "platform", label: "Platform", width: "14%", align: "left" },
  { key: "clientId", label: "Client ID", width: "24%", align: "left" }, // masked
];

export default merchantColumns;
